import React from 'react'
import { ReactComponent as Arrow } from '../images/arrow1.svg'

export default function CtaButton({ children = 'Read More', className, icon = true, as = 'button', ...props }) {
    const As = as
    return (
        <As className={'cta-button button ' + className} {...props}>
            {icon ? <Arrow /> : null}
            <div className='inner-content'>
                {children}
            </div>
        </As>
    )
}
